import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AdminALogoFill32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M2020 1109l-63 240-206-27q-17 26-36 51t-43 47l72 188-214 125-127-166q-62 14-123 14-67 0-131-15t-125-47v-305q45 61 112 95t144 35q66 0 124-25t102-68 69-102 25-125q0-66-25-124t-68-102-102-69-125-25q-76 0-143 34t-113 96V529q61-32 126-47t134-15l80-181 240 63-27 204q55 35 100 80l186-71 124 214-163 125q6 32 9 63t4 64l183 81zM691 607l240 819-235-15-42-167H514l-39 154-211-13 215-765 212-13z" />
    </svg>
  ),
  displayName: 'AdminALogoFill32Icon',
});

export default AdminALogoFill32Icon;
